
<div class="labels-settings">
  <div class="labels-settings-header">
    <div class="label">{{ isBoardSpecificLabelsPage ? 'Boards' : 'General' }} Labels</div>

    <div class="d-flex justify-content-end">
      <button class="badgebutton active mr-2" @click="addNewLabel()">
        <i class="far fa-plus"></i>
        Add New
      </button>

      <button :disabled="!isFormValid" class="btn btn-save btn-sm btn-success" @click="saveLabels()">
        <i class="far fa-save"></i>
        Save changes
      </button>
    </div>
  </div>

  <p v-if="isBoardSpecificLabelsPage">Here you can add/ edit labels which are only available for your board.</p>
  <p v-else>Here you can add/ edit labels which are available to all boards.</p>

  <LabelsTable
    class="mb-1"
    :labelsHeader="'Active Labels'"
    :labels="activeLabels"
    :deleteLabelFunc="deleteLabelAsync"
    :archiveLabelFunc="archiveLabelAsync"
    @labelUpdated="() => isDirty = true"
  />

  <LabelsTable
    class="mt-1"
    :labelsHeader="'Archived Labels'"
    :isArchivedLabels="true"
    :labels="archivedLabels"
    :reactivateLabelFunc="reactivateLabelAsync"
  />
</div>
